import { toast } from "react-toastify";

export const notifyInfo = (message, toastId, link) => {
  toast(
    <div className="success_toast">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M29.6004 23.5113L18.6691 4.52758C18.396 4.06249 18.006 3.67686 17.5379 3.40891C17.0698 3.14096 16.5397 3 16.0004 3C15.461 3 14.931 3.14096 14.4629 3.40891C13.9947 3.67686 13.6048 4.06249 13.3316 4.52758L2.40036 23.5113C2.13753 23.9612 1.99902 24.4728 1.99902 24.9938C1.99902 25.5148 2.13753 26.0265 2.40036 26.4763C2.67003 26.9442 3.05933 27.332 3.52832 27.5997C3.9973 27.8675 4.52909 28.0057 5.06911 28.0001H26.9316C27.4712 28.0052 28.0025 27.8669 28.471 27.5991C28.9395 27.3314 29.3284 26.9439 29.5979 26.4763C29.8611 26.0267 30 25.5152 30.0005 24.9942C30.0009 24.4732 29.8628 23.9614 29.6004 23.5113ZM15.0004 13.0001C15.0004 12.7349 15.1057 12.4805 15.2933 12.293C15.4808 12.1054 15.7351 12.0001 16.0004 12.0001C16.2656 12.0001 16.5199 12.1054 16.7075 12.293C16.895 12.4805 17.0004 12.7349 17.0004 13.0001V18.0001C17.0004 18.2653 16.895 18.5197 16.7075 18.7072C16.5199 18.8947 16.2656 19.0001 16.0004 19.0001C15.7351 19.0001 15.4808 18.8947 15.2933 18.7072C15.1057 18.5197 15.0004 18.2653 15.0004 18.0001V13.0001ZM16.0004 24.0001C15.7037 24.0001 15.4137 23.9121 15.167 23.7473C14.9203 23.5825 14.7281 23.3482 14.6145 23.0741C14.501 22.8 14.4713 22.4984 14.5292 22.2074C14.5871 21.9165 14.7299 21.6492 14.9397 21.4394C15.1495 21.2296 15.4168 21.0868 15.7077 21.0289C15.9987 20.971 16.3003 21.0007 16.5744 21.1143C16.8485 21.2278 17.0827 21.4201 17.2476 21.6667C17.4124 21.9134 17.5004 22.2034 17.5004 22.5001C17.5004 22.8979 17.3423 23.2794 17.061 23.5607C16.7797 23.842 16.3982 24.0001 16.0004 24.0001Z"
          fill="#F1C50E"
        />
      </svg>
      <div id="popup-login-success">
        <p>{message}</p>
        {/* <a href={link}>{link}</a> */}
      </div>
    </div>,
    {
      position: "top-right",
      autoClose: 5000,
      className: "toast-info",
      toastId: toastId ?? `info-${message}`,
    },
  );
};
